module.exports = __webpack_public_path__ + "static/media/icon-calender.ab6d2472.svg";